var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.269,
    height: 17.271,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5200f1",
    stroke: "#5200f1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 180",
    d: "M15.646 1.625a3.853 3.853 0 00-5.442 0l-2.72 2.72a.592.592 0 10.837.837l2.721-2.721a2.664 2.664 0 013.767 3.768l-3.558 3.559a2.668 2.668 0 01-3.768 0 .592.592 0 00-.837.837 3.852 3.852 0 005.442 0l3.558-3.558a3.857 3.857 0 000-5.442z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 181",
    d: "M8.53 12.509l-2.3 2.3a2.664 2.664 0 01-3.767-3.767l3.349-3.349a2.674 2.674 0 013.767 0 .592.592 0 10.837-.837 3.853 3.853 0 00-5.442 0l-3.351 3.351a3.848 3.848 0 005.442 5.441l2.3-2.3a.592.592 0 00-.837-.837z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/Website.0da299ac7b0b9ec4dae224f1f0f92b5a.svg";
export { ForwardRef as ReactComponent };